/** Vite exposes `VITE_*` vars; `define` in vite.config may also set VITE_API_BASE_URL from NEXT_PUBLIC_API_BASE_URL. */

export const envConfig = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
  /** Absolute URLs for hero video (Cloudflare Pages limit 25 MiB — host large files on Supabase Storage). */
  heroVideoWebmUrl: String(import.meta.env.VITE_HERO_VIDEO_WEBM_URL ?? '').trim(),
  heroVideoMovUrl: String(import.meta.env.VITE_HERO_VIDEO_MOV_URL ?? '').trim(),
};
